import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerComponent from "../components/multi_cotizacion/banner.component";
import DescriptionComponent from "../components/multi_cotizacion/description.component";
import CotizacionVehiculosComponent from "../components/multi_cotizacion/cotizacion-vehiculos.component";
import VehiculosComponent from "../components/multi_cotizacion/vehiculos.component";
import {
  multicotizador,
  vehiclesSimulator,
} from "../components/conexion/vehicles.conexion";

import { Skeleton } from "@mui/material";

const CotizadorPlaceholder = () => (
  <div id="cotizador" style={{ width: "100%", padding: "40px 7%", boxSizing: "border-box" }}>
    <Skeleton 
      variant="rectangular" 
      width="100%" 
      height={900} 
      sx={{ borderRadius: "20px" }} 
    />
  </div>
);

const MultiCotizacionPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [vehiculosData, setVehiculosData]: any = useState([]);
  const [vehiculosSelected, setVehiculosSelected]: any = useState(null);
  const [multicotizadorData, setMulticotizadorData]: any = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      vehiclesSimulator(),
      multicotizador()
    ]).then(([vehiclesRes, multicotizadorRes]) => {
      let data: any = vehiclesRes?.data?.data;
      setVehiculosData(data);
      setVehiculosSelected(data[0]);
      setMulticotizadorData(multicotizadorRes?.data?.data);
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <div className="home-page-mascara"></div>
        <BannerComponent multicotizadorData={multicotizadorData} />
        <DescriptionComponent multicotizadorData={multicotizadorData} />

        <div className="cotizacion-multiple-component" id="cotizacion">
          {isLoading ? (
            <CotizadorPlaceholder />
          ) : (
            <>
              <VehiculosComponent
                vehiculosData={vehiculosData}
                setVehiculosSelected={setVehiculosSelected}
              />
              {vehiculosSelected !== null && (
                <CotizacionVehiculosComponent vehiculo={vehiculosSelected} />
              )}
            </>
          )}
        </div>
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default MultiCotizacionPage;